import { render, staticRenderFns } from "./TaskCalendar.vue?vue&type=template&id=3ef1a1ca&scoped=true"
import script from "./TaskCalendar.vue?vue&type=script&lang=js"
export * from "./TaskCalendar.vue?vue&type=script&lang=js"
import style0 from "./TaskCalendar.vue?vue&type=style&index=0&id=3ef1a1ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef1a1ca",
  null
  
)

export default component.exports